 module.exports = function(app) {
  'use strict';
  // app.config(appConfig);
  // appConfig.$inject = ['$stateProvider', '$urlRouterProvider'];
  // function appConfig($stateProvider, $urlRouterProvider) {
  //   $stateProvider
  //     .state('home', {
  //         url: '/home',
  //         abstract: true,
  //         template: require('./home.html')
  //     });

  //   $urlRouterProvider.otherwise(function ($injector) {
  //       var $state = $injector.get('$state');
  //       $state.go('login');
  //   });
  // }
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/appConfig.js
// module id = 423
// module chunks = 0